import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { IconButton, Tooltip } from '@sumologic/yama-ds-components';

import Icon from '~/components/Icon/Icon';
import Translate from '~/components/Translate/Translate';

import QueryAction from './QueryAction';
import QueryList from './QueryList';

const Query = ({
    filterValue, // preferencesContext.filterBarString
    clearFilter, // preferencesContext.clearFilterBar -> 𝘵𝘳𝘪𝘨𝘨𝘦𝘳 𝘐𝘯𝘱𝘶𝘵𝘉𝘢𝘳 handleChange 𝘵𝘩𝘢𝘵 𝘢𝘭𝘳𝘦𝘢𝘥𝘺 𝘴𝘵𝘰𝘳𝘦 𝘱𝘳𝘦𝘧𝘦𝘳𝘦𝘯𝘤𝘦𝘴
    updateQueries, // preferencesContext.setUserQueries
    availableQueries,
    enableBookmarks,
    children
}) => {
    const queries = availableQueries || [];

    const handleClearFilter = useCallback(() => {
        clearFilter({ savePreferences: true });
    }, [clearFilter]);

    return (
        <>
            {filterValue && (
                <div className="reset-search input-group-append d-flex">
                    <Tooltip
                        title={<Translate message="Reset search" />}
                        placement="bottom"
                        arrow
                    >
                        <IconButton onClick={handleClearFilter} size="small">
                            <Icon type="cross" size="sm" />
                        </IconButton>
                    </Tooltip>
                </div>
            )}
            <QueryAction
                filterValue={filterValue}
                enableBookmarks={enableBookmarks}
                queries={queries}
                updateQueries={updateQueries}
            />
            {children || null}
            {queries.length > 0 && (
                <QueryList
                    filterValue={filterValue}
                    enableBookmarks={enableBookmarks}
                    queries={queries}
                    updateQueries={updateQueries}
                />
            )}
        </>
    );
};

Query.propTypes = {
    filterValue: PropTypes.string,
    clearFilter: PropTypes.func,
    updateQueries: PropTypes.func,
    availableQueries: PropTypes.array,
    enableBookmarks: PropTypes.bool
};

Query.defaultProps = {
    enableBookmarks: true,
    updateQueries: () => {},
    clearFilter: () => {}
};

export default Query;
